<!--
  EntityInputText.vue — the `entity-input-text` widget (and its text-like
  aliases: bigtext/email/phone/integer/decimal/password) from the per-type UI
  triad (entity-form-view-mixin getFormCmp -> entity-input-<type>).

  Reconstructed from lacak.io deployed behavior; app-specific contract verbatim
  (props value/field/rules/disabled/label; emits `input`; type dispatch maps
  bigtext->textarea, password->password, integer/decimal->number), internal impl
  re-authored on Vuetify 1.5 controls.
-->
<template>
  <v-textarea
    v-if="isBigText"
    :value="value"
    :label="resolvedLabel"
    :rules="rules"
    :disabled="disabled"
    :required="required"
    auto-grow
    rows="3"
    @input="onInput"
  />
  <v-text-field
    v-else
    :value="value"
    :label="resolvedLabel"
    :rules="rules"
    :disabled="disabled"
    :required="required"
    :type="inputType"
    :append-icon="isPassword ? (reveal ? 'visibility' : 'visibility_off') : undefined"
    @click:append="reveal = !reveal"
    @input="onInput"
  />
</template>

<script>
export default {
  name: 'entity-input-text',
  props: {
    value: { default: null },
    field: { type: Object, default: () => ({}) },
    rules: { type: Array, default: () => [] },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: '' },
  },
  data() {
    return { reveal: false };
  },
  computed: {
    type() { return (this.field && this.field.type) || 'text'; },
    isBigText() { return this.type === 'bigtext'; },
    isPassword() { return this.type === 'password'; },
    isNumeric() { return this.type === 'integer' || this.type === 'decimal'; },
    required() { return !!(this.field && this.field.required); },
    resolvedLabel() { return this.label || (this.field && this.field.label) || ''; },
    inputType() {
      if (this.isPassword) return this.reveal ? 'text' : 'password';
      if (this.isNumeric) return 'number';
      if (this.type === 'email') return 'email';
      if (this.type === 'phone') return 'tel';
      return 'text';
    },
  },
  methods: {
    onInput(val) {
      if (this.isNumeric && val !== '' && val != null) {
        const n = this.type === 'integer' ? parseInt(val, 10) : parseFloat(val);
        this.$emit('input', Number.isNaN(n) ? null : n);
        return;
      }
      this.$emit('input', val === '' ? (this.isNumeric ? null : '') : val);
    },
  },
};
</script>
